import mixpanel from 'mixpanel-browser';
import userflow from 'userflow.js';

import axios from 'services/axios';
import { PROFILE } from 'services/consts';

import AppLogger from 'utils/AppLogger';
import { store } from 'utils/configureStore';

const fetchRoles = async () => {
	await axios
		.post(PROFILE.GET_ROLES)
		.then((response) => {
			if (response.status === 200) {
				const userData = store.getState().user;

				store.dispatch({
					type: 'systemRoles/setRoles',
					payload: [
						userData.planName,
						userData.userType,
						...response.data.filter(
							(role) => !(role.startsWith('/actions/') || role.startsWith('/rowActions/'))
						)
					]
				});

				store.dispatch({
					type: 'actionRoles/setActions',
					payload: response.data.filter(
						(role) => role.startsWith('/actions/') || role.startsWith('/rowActions/')
					)
				});

				const modules = response.data.filter((role) => !role.includes('/'));
				try {
					if (userflow.isIdentified()) {
						userflow.updateUser({
							modules
						});
					}
				} catch {
					// do nothing
				}

				try {
					mixpanel.people.set({
						modules
					});
				} catch {
					// do nothing
				}
			} else {
				AppLogger.error(response);
			}
		})
		.catch((error) => {
			AppLogger.error(error);
		});
};

export default fetchRoles;
